export default [
    {
        name: 'header',
        sortField: 'header',
        type: 'string',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'txt',
        sortField: 'txt',
        type: 'string',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: 'links',
        sortField: 'links',
        type: 'string',
        callback: 'arraySemicolon',
        useInFilter: true
    },
    {
        name: '__slot:ads_url',
        sortField: 'url',
        type: 'string',
        useInFilter: true
    },
    {
        name: '__slot:keyscnt',
        sortField: 'keyscnt',
        dataClass: 'ral',
        type: 'number',
        useInFilter: true,
        isDefault: true
    },
    {
        name: 'serp',
        sortField: 'serp',
        type: 'dateRange',
        dataClass: 'ral',
        useInFilter: true,
    },
]
